export const translations = {
  ru: {
    // Header
    menuAbout: 'О нас',
    menuPrograms: 'Программы',
    menuTraining: 'Обучение',
    menuPartners: 'Партнеры',
    menuContacts: 'Контакты',
    buttonLogin: 'Войти в LMS',
    
    // Hero
    heroTitle: 'Обучаем будущих лидеров искусственного интеллекта',
    heroSubtitle: 'Программы для студентов, преподавателей и топ-менеджеров — от основ до внедрения AI-решений',
    heroButton: 'Начать обучение',
    
    // About
    aboutTag: 'О нас',
    aboutTitle: 'Shai Academy',
    aboutDescription: 'Это образовательная экосистема, которая помогает студентам и профессионалам освоить искусственный интеллект и применять его в реальных проектах',
    aboutEducation: 'Образовательные программы для вузов',
    aboutEducationText: 'Курсы GenAI, хакатоны и проекты на реальных данных. Формируем AI-грамотность студентов и преподавателей',
    aboutConsulting: 'AI-консалтинг',
    aboutConsultingText: 'Определяем зоны выгоды, помогаем командам внедрить AI-инструменты, проектируем пилот и настраиваем процессы',
    aboutCorporate: 'Корпоративное обучение',
    aboutCorporateText: 'Интенсивы 2–5 дней: ваши кейсы → готовые решения → формирование AI-навыков у сотрудников',
    
    // Programs
    programsTag: 'Программы',
    programsTitle: 'Программы обучения',
    programsSubtitle: 'Выберите свою траекторию',
    programsStudents: 'Для студентов',
    programsStudentsText: 'AI-грамотность + практические навыки GenAI. Результат — готовый проект и понимание, как использовать ИИ в профессии',
    programsStudentsButton: 'Посмотреть программу',
    programsTeachers: 'Для преподавателей',
    programsTeachersText: 'Методики преподавания ИИ, оценивание с AI, академическая честность, создание собственных AI-помощников кафедры',
    programsTeachersButton: 'Открыть программу',
    programsManagers: 'Для руководителей и топ-менеджеров',
    programsManagersText: 'AI-стратегия, отбор пилотов, управление рисками и внедрение Responsible AI',
    programsManagersButton: 'Запросить консультацию',
    
    // Cases
    casesTitle: 'Кейсы',
    
    // Partners
    partnersTag: 'Партнеры',
    partnersTitle: 'Нам доверяют лидеры отрасли',
    
    // University Experience
    universityTitle: 'Сотрудничаем с ведущими университетами и исследовательскими центрами',
    universityIssai: 'Партнёрство с ISSAI',
    universityIssaiText: 'Подписан меморандум о сотрудничестве в области on-prem AI-решений (LLM, STT, TTS) для совместной разработки и интеграции национальных моделей искусственного интеллекта.',
    universityAitu: 'AITU x shai.pro',
    universityAituText1: 'Внедрён AI-агент для приёмной кампании Astana IT University — цифровой помощник для абитуриентов и их родителей.',
    universityAituText2: '16 000+ обработанных сообщений 100% вовлечённость пользователей Работа в режиме реального времени и безопасное локальное (on-prem) развертывание',
    
    // Statistics
    statisticsNumber: '5000+',
    statisticsDescription: 'Студентов прошли обучение у наших преподавателей в университетах и практических IT-программах',
    statisticsMnuText: 'выпускников партнёрского направления IT & Business с MNU и Hof University',
    statisticsMnuTextSmall: 'в настоящее время обучаются на курсе по Generative AI, запущенном в 2025 году.',
    statisticsAituText: 'студентов AITU прошли обучение по IT-дисциплинам',
    statisticsAituTextSmall: 'получили фундаментальные знания в области искусственного интеллекта через высокоэффективные университетские курсы, включая Advanced Programming, Data Analysis и Blockchain Technologies.',
    statisticsAlphaText: 'студентов, обученных по IT-программам Alpha Education',
    statisticsAlphaTextSmall: 'Alpha Education — это EdTech-компания, предоставляющая практическое обучение в области IT для нового поколения digital-профессионалов. Alpha Education является участником Tech Orda (государственной программы по развитию цифровых навыков) и официальным резидентом Astana Hub.',
    
    // Corporate Training
    corporateTitle: 'Наш опыт корпоративного обучения:',
    corporateElidiTitle: '«Elidi Securities Ltd» (Кипр)',
    corporateElidiText1: 'В марте 2025 года проведён 2-дневный воркшоп для 10 сотрудников Elidi Securities',
    corporateElidiText2: 'Темы: GenAI, Agentic AI, поиск бизнес-кейсов и разработка пилотных идей',
    corporateElidiText3: 'Результатом стало формирование первых направлений внедрения GenAI в корпоративные процессы',
    corporateAltTitle: 'ALT University (Алматы)',
    corporateAltText1: 'Команда shai.pro выступила на форуме «Использование ИИ в системе высшего образования и науки», организованном МНВО, Ассоциацией ВУЗов РК и ALT University',
    corporateAltText2: 'Провели воркшоп для руководителей вузов',
    corporateAltText3: 'Участники создали более 60 AI-агентов за 2 часа, применимых в управлении и обучении',
    
    // Hackathons
    hackathonsTitle: 'AI Хакатоны',
    hackathonGenaiTitle: 'GenAI Hackathon (Апрель 2025)',
    hackathonGenaiSubtitle: 'Первый хакатон shai.pro — поиск и развитие талантов',
    hackathonGenaiText1: '120 заявок 23 финалиста 15 стажёров, из которых 12 продолжают работать в компании',
    hackathonGenaiText2: 'Участники создавали и обучали AI-агентов на платформе shai.pro, решая реальные бизнес-задачи',
    hackathonAiTitle: 'AI-Hackathon by shai.pro (Сентябрь 2025)',
    hackathonAiSubtitle: 'Крупнейший AI-хакатон в Казахстане:',
    hackathonAiText1: '700+ заявок 30 финальных команд Призовой фонд — 21 000 000 тенге',
    hackathonAiText2: 'Команды решали 10 практических задач, создавая AI-решения на shai.pro и других платформах',
    hackathonAiText3: '6 победителей получили призы за лучшие проекты и оригинальные AI-агенты',
    
    // KEGOC
    kegocTitle: 'АО «KEGOC»',
    kegocKmgTitle: 'АО «KMG Engineering»',
    kegocText1: 'Провели управленческий воркшоп по искусственному интеллекту для топ-менеджмента АО «KEGOC»',
    kegocText2: 'В мероприятии приняли участие 11 руководителей, включая Председателя Правления.',
    kegocText3: 'Рассмотрены темы внедрения AI в промышленные системы, разработки корпоративных ассистентов и построения дорожной карты AI-трансформации.',
    kegocKmgText1: 'Провели практический воркшоп по AI-инструментам для 121 участника',
    kegocKmgText2: '12 команд создали креативные видео на тему «Молодёжь KMG Engineering» с использованием генеративных технологий',
    kegocKmgText3: '5 лучших команд получили номинации «Лучшая идея», «Лучшая озвучка», «Самое вдохновляющее видео», «Лучшая командная работа», «Лучшая визуальное оформление»',
    
    // Banner
    bannerTitle: 'Развиваем будущее вместе',
    bannerDescription: 'Мы сотрудничаем с университетами, IT-компаниями и госструктурами, создавая программы, которые помогают применять современные технологии и AI-решения на практике',
    bannerButton: 'Связаться с нами',
    
    // Form
    formTitle: 'Готовы начать обучение с Shai Academy?',
    formSubtitle: 'Оставьте заявку — и команда Shai Academy поможет вам выбрать подходящее направление',
    formName: 'Имя',
    formNamePlaceholder: 'Введите имя',
    formEmail: 'E-mail',
    formEmailPlaceholder: 'Введите e-mail',
    formOrganization: 'Организация',
    formOrganizationPlaceholder: 'Введите название организации',
    formMessage: 'Сообщение',
    formMessagePlaceholder: 'Оставьте сообщение для нас',
    formButton: 'Отправить',
    
    // Footer
    footerProducts: 'Продукты',
    footerCompany: 'Компания',
    footerLegal: 'Юридическая информация',
    footerProductAgents: 'AI-агенты & Shai Tools',
    footerProductIndustries: 'Отраслевые решения',
    footerProductCases: 'Кейсы',
    footerCompanyAbout: 'О компании',
    footerCompanyCareer: 'Карьера',
    footerCompanyContacts: 'Контакты',
    footerLegalPrivacy: 'Политика конфиденциальности',
    footerLegalOffer: 'Публичная оферта',
    footerLegalSecurity: 'Безопасность',
    footerAddress: 'Адрес:',
    footerEmail: 'E-mail:',
    footerPhone: 'Телефон:',
    footerCopyright: '© 2025 shai.academy | All rights reserved',
    footerPrivacy: 'Политика конфиденциальности',
  },
  
  kz: {
    // Header
    menuAbout: 'Біз туралы',
    menuPrograms: 'Бағдарламалар',
    menuTraining: 'Оқыту',
    menuPartners: 'Серіктестер',
    menuContacts: 'Байланыстар',
    buttonLogin: 'LMS-ке кіру',
    
    // Hero
    heroTitle: 'Жасанды интеллект келешегінің көшбасшыларын дайындаймыз',
    heroSubtitle: 'Студенттер, оқытушылар және топ-менеджерлерге арналған бағдарламалар — негіздерден AI-шешімдерді енгізуге дейін',
    heroButton: 'Оқуды бастау',
    
    // About
    aboutTag: 'Біз туралы',
    aboutTitle: 'Shai Academy',
    aboutDescription: 'Бұл студенттер мен мамандарға жасанды интеллектті меңгеруге және оны нақты жобаларда қолдануға көмектесетін білім беру экожүйесі',
    aboutEducation: 'ЖОО-ға арналған білім беру бағдарламалары',
    aboutEducationText: 'GenAI курстары, хакатондар және нақты деректер бойынша жобалар. Студенттер мен оқытушылардың AI-сауаттылығын қалыптастырамыз',
    aboutConsulting: 'AI-консалтинг',
    aboutConsultingText: 'Пайда аймақтарын анықтаймыз, командаларға AI-құралдарды енгізуге көмектесеміз, пилотты жобалаймыз және процестерді баптаймыз',
    aboutCorporate: 'Корпоративтік оқыту',
    aboutCorporateText: 'Интенсивтер 2–5 күн: сіздің кейстеріңіз → дайын шешімдер → қызметкерлердің AI-дағдыларын қалыптастыру',
    
    // Programs
    programsTag: 'Бағдарламалар',
    programsTitle: 'Оқу бағдарламалары',
    programsSubtitle: 'Өз траекторияңызды таңдаңыз',
    programsStudents: 'Студенттерге',
    programsStudentsText: 'AI сауаттылығы + GenAI практикалық дағдылары. Нәтиже — дайын жоба және ИИ-ды кәсіпте қалай қолдану керектігін түсіну',
    programsStudentsButton: 'Бағдарламаны көру',
    programsTeachers: 'Оқытушыларға',
    programsTeachersText: 'ИИ оқыту әдістемелері, AI көмегімен бағалау, академиялық адалдық, кафедраның жеке AI-көмекшілерін құру',
    programsTeachersButton: 'Бағдарламаны ашу',
    programsManagers: 'Басшылар мен топ-менеджерлерге',
    programsManagersText: 'AI-стратегия, пилоттарды іріктеу, тәуекелдерді басқару және Responsible AI енгізу',
    programsManagersButton: 'Кеңес сұрау',
    
    // Cases
    casesTitle: 'Кейстер',
    
    // Partners
    partnersTag: 'Серіктестер',
    partnersTitle: 'Сауда көшбасшылары бізге сенеді',
    
    // University Experience
    universityTitle: 'Жетекші университеттер мен зерттеу орталықтарымен ынтымақтастық',
    universityIssai: 'ISSAI-мен серіктестік',
    universityIssaiText: 'Ұлттық жасанды интеллект модельдерін бірлесіп әзірлеу және интеграциялау үшін on-prem AI-шешімдер (LLM, STT, TTS) саласында ынтымақтастық туралы меморандумға қол қойылды.',
    universityAitu: 'AITU x shai.pro',
    universityAituText1: 'Astana IT University қабылдау науқаны үшін AI-агент енгізілді — түлектер мен олардың ата-анасы үшін сандық көмекші.',
    universityAituText2: '16 000+ өңделген хабарлама 100% пайдаланушылардың қатысуы Нақты уақыт режимінде жұмыс және қауіпсіз жергілікті (on-prem) орналастыру',
    
    // Statistics
    statisticsNumber: '5000+',
    statisticsDescription: 'Студенттер біздің оқытушыларымыздан университеттер мен практикалық IT-бағдарламаларда оқыды',
    statisticsMnuText: 'MNU және Hof University-мен IT & Business серіктестік бағытының түлектері',
    statisticsMnuTextSmall: 'қазіргі уақытта 2025 жылы іске қосылған Generative AI курсында оқып жатыр.',
    statisticsAituText: 'AITU студенттері IT-пәндер бойынша оқудан өтті',
    statisticsAituTextSmall: 'Advanced Programming, Data Analysis және Blockchain Technologies-ті қоса алғанда, жоғары тиімді университеттік курстар арқылы жасанды интеллект саласында негізгі білім алды.',
    statisticsAlphaText: 'Alpha Education IT-бағдарламалары бойынша оқытылған студенттер',
    statisticsAlphaTextSmall: 'Alpha Education — жаңа буын digital-мамандарына IT саласында практикалық оқыту ұсынатын EdTech-компания. Alpha Education Tech Orda-ның (сандық дағдыларды дамытудың мемлекеттік бағдарламасы) қатысушысы және Astana Hub-тың ресми тұрғыны.',
    
    // Corporate Training
    corporateTitle: 'Біздің корпоративтік оқыту тәжірибесі:',
    corporateElidiTitle: '«Elidi Securities Ltd» (Кипр)',
    corporateElidiText1: '2025 жылдың наурызында Elidi Securities-тың 10 қызметкеріне 2 күндік воркшоп өткізілді',
    corporateElidiText2: 'Тақырыптар: GenAI, Agentic AI, бизнес-кейстерді іздеу және пилоттық идеяларды әзірлеу',
    corporateElidiText3: 'Нәтижесінде корпоративтік процестерге GenAI енгізудің алғашқы бағыттары қалыптасты',
    corporateAltTitle: 'ALT University (Алматы)',
    corporateAltText1: 'shai.pro командасы МҰБҰ, ҚР ЖОО Ассоциациясы және ALT University ұйымдастырған «Жоғары білім және ғылым жүйесінде ИИ пайдалану» форумында сөз сөйледі',
    corporateAltText2: 'ЖОО басшыларына воркшоп өткіздік',
    corporateAltText3: 'Қатысушылар басқару мен оқытуда қолданылатын 60-тан астам AI-агенттерді 2 сағат ішінде жасады',
    
    // Hackathons
    hackathonsTitle: 'AI Хакатондар',
    hackathonGenaiTitle: 'GenAI Hackathon (Сәуір 2025)',
    hackathonGenaiSubtitle: 'shai.pro-дың алғашқы хакатоны — таланттарды іздеу және дамыту',
    hackathonGenaiText1: '120 өтініш 23 финалист 15 тәжірибелік, оның ішінде 12-сі компанияда жұмыс істейді',
    hackathonGenaiText2: 'Қатысушылар shai.pro платформасында AI-агенттерді жасап, оқытып, нақты бизнес-мәселелерді шешті',
    hackathonAiTitle: 'shai.pro AI-Hackathon (Қыркүйек 2025)',
    hackathonAiSubtitle: 'Қазақстандағы ең ірі AI-хакатон:',
    hackathonAiText1: '700+ өтініш 30 финалдық команда Жүлделік қор — 21 000 000 теңге',
    hackathonAiText2: 'Командалар shai.pro және басқа платформаларда AI-шешімдерді жасай отырып, 10 практикалық мәселені шешті',
    hackathonAiText3: '6 жеңімпаз ең жақсы жобалар мен түпнұсқа AI-агенттер үшін жүлделер алды',
    
    // KEGOC
    kegocTitle: '«KEGOC» АҚ',
    kegocKmgTitle: '«KMG Engineering» АҚ',
    kegocText1: '«KEGOC» АҚ топ-менеджментіне жасанды интеллект бойынша басқару воркшопы өткіздік',
    kegocText2: 'Оқиғаға Басқарма Төрағасын қоса алғанда, 11 басшы қатысты.',
    kegocText3: 'AI-ды өнеркәсіптік жүйелерге енгізу, корпоративтік ассистенттерді әзірлеу және AI-трансформация жол картасын құру тақырыптары қарастырылды.',
    kegocKmgText1: '121 қатысушыға AI-құралдар бойынша практикалық воркшоп өткіздік',
    kegocKmgText2: '12 команда генеративтік технологияларды пайдаланып «KMG Engineering жастары» тақырыбында креативті бейнелер жасады',
    kegocKmgText3: '5 ең жақсы команда «Ең жақсы идея», «Ең жақсы дауыстау», «Ең шабыттандыратын бейне», «Ең жақсы командалық жұмыс», «Ең жақсы көрініс дизайны» номинацияларын алды',
    
    // Banner
    bannerTitle: 'Біз бірге келешекті дамытамыз',
    bannerDescription: 'Біз университеттермен, IT-компаниялармен және мемлекеттік құрылымдармен ынтымақтасып, заманауи технологиялар мен AI-шешімдерді тәжірибеде қолдануға көмектесетін бағдарламалар жасаймыз',
    bannerButton: 'Бізбен байланысу',
    
    // Form
    formTitle: 'Shai Academy-мен оқуды бастауға дайынсыз ба?',
    formSubtitle: 'Өтініш қалдырыңыз — және Shai Academy командасы сізге сәйкес бағытты таңдауға көмектеседі',
    formName: 'Аты',
    formNamePlaceholder: 'Атыңызды енгізіңіз',
    formEmail: 'E-mail',
    formEmailPlaceholder: 'E-mail енгізіңіз',
    formOrganization: 'Ұйым',
    formOrganizationPlaceholder: 'Ұйым атауын енгізіңіз',
    formMessage: 'Хабарлама',
    formMessagePlaceholder: 'Бізге хабарлама қалдырыңыз',
    formButton: 'Жіберу',
    
    // Footer
    footerProducts: 'Өнімдер',
    footerCompany: 'Компания',
    footerLegal: 'Құқықтық ақпарат',
    footerProductAgents: 'AI-агенттер & Shai Tools',
    footerProductIndustries: 'Санаттық шешімдер',
    footerProductCases: 'Кейстер',
    footerCompanyAbout: 'Компания туралы',
    footerCompanyCareer: 'Мансап',
    footerCompanyContacts: 'Байланыстар',
    footerLegalPrivacy: 'Құпиялылық саясаты',
    footerLegalOffer: 'Қоғамдық ұсыныс',
    footerLegalSecurity: 'Қауіпсіздік',
    footerAddress: 'Мекен-жайы:',
    footerEmail: 'E-mail:',
    footerPhone: 'Телефон:',
    footerCopyright: '© 2025 shai.academy | Барлық құқықтар қорғалған',
    footerPrivacy: 'Құпиялылық саясаты',
  },
  
  en: {
    // Header
    menuAbout: 'About',
    menuPrograms: 'Programs',
    menuTraining: 'Training',
    menuPartners: 'Partners',
    menuContacts: 'Contacts',
    buttonLogin: 'Login to LMS',
    
    // Hero
    heroTitle: 'Training Future Leaders of Artificial Intelligence',
    heroSubtitle: 'Programs for students, teachers, and top managers — from basics to AI solution implementation',
    heroButton: 'Start Learning',
    
    // About
    aboutTag: 'About',
    aboutTitle: 'Shai Academy',
    aboutDescription: 'This is an educational ecosystem that helps students and professionals master artificial intelligence and apply it in real projects',
    aboutEducation: 'Educational Programs for Universities',
    aboutEducationText: 'GenAI courses, hackathons and projects on real data. We develop AI literacy for students and teachers',
    aboutConsulting: 'AI Consulting',
    aboutConsultingText: 'We identify benefit zones, help teams implement AI tools, design pilots and configure processes',
    aboutCorporate: 'Corporate Training',
    aboutCorporateText: '2–5 day intensives: your cases → ready solutions → developing AI skills in employees',
    
    // Programs
    programsTag: 'Programs',
    programsTitle: 'Training Programs',
    programsSubtitle: 'Choose your path',
    programsStudents: 'For Students',
    programsStudentsText: 'AI literacy + practical GenAI skills. Result — a ready project and understanding of how to use AI in your profession',
    programsStudentsButton: 'View Program',
    programsTeachers: 'For Teachers',
    programsTeachersText: 'AI teaching methodologies, AI-assisted assessment, academic integrity, creating your own department AI assistants',
    programsTeachersButton: 'Open Program',
    programsManagers: 'For Executives and Top Managers',
    programsManagersText: 'AI strategy, pilot selection, risk management and Responsible AI implementation',
    programsManagersButton: 'Request Consultation',
    
    // Cases
    casesTitle: 'Cases',
    
    // Partners
    partnersTag: 'Partners',
    partnersTitle: 'Industry Leaders Trust Us',
    
    // University Experience
    universityTitle: 'Cooperation with Leading Universities and Research Centers',
    universityIssai: 'Partnership with ISSAI',
    universityIssaiText: 'A memorandum of cooperation in the field of on-prem AI solutions (LLM, STT, TTS) has been signed for joint development and integration of national artificial intelligence models.',
    universityAitu: 'AITU x shai.pro',
    universityAituText1: 'An AI agent has been implemented for the Astana IT University admission campaign — a digital assistant for applicants and their parents.',
    universityAituText2: '16,000+ processed messages 100% user engagement Real-time operation and secure local (on-prem) deployment',
    
    // Statistics
    statisticsNumber: '5000+',
    statisticsDescription: 'Students have been trained by our teachers across universities and hands-on IT programs',
    statisticsMnuText: 'graduates of the IT & Business partnership program with MNU and Hof University',
    statisticsMnuTextSmall: 'currently studying in the Generative AI course launched in 2025.',
    statisticsAituText: 'AITU students completed training in IT disciplines',
    statisticsAituTextSmall: 'received fundamental knowledge in artificial intelligence through highly effective university courses, including Advanced Programming, Data Analysis, and Blockchain Technologies.',
    statisticsAlphaText: 'students trained in Alpha Education IT programs',
    statisticsAlphaTextSmall: 'Alpha Education is an EdTech company providing practical IT training for the new generation of digital professionals. Alpha Education is a participant in Tech Orda (a state program for digital skills development) and an official resident of Astana Hub.',
    
    // Corporate Training
    corporateTitle: 'Our Corporate Training Experience:',
    corporateElidiTitle: '«Elidi Securities Ltd» (Cyprus)',
    corporateElidiText1: 'In March 2025, a 2-day workshop was held for 10 Elidi Securities employees',
    corporateElidiText2: 'Topics: GenAI, Agentic AI, business case search and pilot idea development',
    corporateElidiText3: 'The result was the formation of the first directions for GenAI implementation in corporate processes',
    corporateAltTitle: 'ALT University (Almaty)',
    corporateAltText1: 'The shai.pro team spoke at the forum "Use of AI in Higher Education and Science System" organized by MES, Association of Universities of Kazakhstan and ALT University',
    corporateAltText2: 'Conducted a workshop for university leaders',
    corporateAltText3: 'Participants created more than 60 AI agents in 2 hours, applicable in management and education',
    
    // Hackathons
    hackathonsTitle: 'AI Hackathons',
    hackathonGenaiTitle: 'GenAI Hackathon (April 2025)',
    hackathonGenaiSubtitle: 'First shai.pro hackathon — talent search and development',
    hackathonGenaiText1: '120 applications 23 finalists 15 interns, 12 of whom continue to work in the company',
    hackathonGenaiText2: 'Participants created and trained AI agents on the shai.pro platform, solving real business problems',
    hackathonAiTitle: 'AI-Hackathon by shai.pro (September 2025)',
    hackathonAiSubtitle: 'Largest AI hackathon in Kazakhstan:',
    hackathonAiText1: '700+ applications 30 final teams Prize fund — 21,000,000 tenge',
    hackathonAiText2: 'Teams solved 10 practical tasks, creating AI solutions on shai.pro and other platforms',
    hackathonAiText3: '6 winners received prizes for best projects and original AI agents',
    
    // KEGOC
    kegocTitle: 'JSC «KEGOC»',
    kegocKmgTitle: 'JSC «KMG Engineering»',
    kegocText1: 'Conducted a management workshop on artificial intelligence for the top management of JSC «KEGOC»',
    kegocText2: '11 leaders participated in the event, including the Chairman of the Board.',
    kegocText3: 'Topics of AI implementation in industrial systems, corporate assistant development, and building an AI transformation roadmap were considered.',
    kegocKmgText1: 'Conducted a practical workshop on AI tools for 121 participants',
    kegocKmgText2: '12 teams created creative videos on the theme "KMG Engineering Youth" using generative technologies',
    kegocKmgText3: '5 best teams received nominations "Best Idea", "Best Voiceover", "Most Inspiring Video", "Best Teamwork", "Best Visual Design"',
    
    // Banner
    bannerTitle: 'Building the Future Together',
    bannerDescription: 'We cooperate with universities, IT companies, and government structures, creating programs that help apply modern technologies and AI solutions in practice',
    bannerButton: 'Contact Us',
    
    // Form
    formTitle: 'Ready to Start Learning with Shai Academy?',
    formSubtitle: 'Leave a request — and the Shai Academy team will help you choose the right direction',
    formName: 'Name',
    formNamePlaceholder: 'Enter your name',
    formEmail: 'E-mail',
    formEmailPlaceholder: 'Enter e-mail',
    formOrganization: 'Organization',
    formOrganizationPlaceholder: 'Enter organization name',
    formMessage: 'Message',
    formMessagePlaceholder: 'Leave a message for us',
    formButton: 'Submit',
    
    // Footer
    footerProducts: 'Products',
    footerCompany: 'Company',
    footerLegal: 'Legal Information',
    footerProductAgents: 'AI Agents & Shai Tools',
    footerProductIndustries: 'Industry Solutions',
    footerProductCases: 'Cases',
    footerCompanyAbout: 'About Us',
    footerCompanyCareer: 'Career',
    footerCompanyContacts: 'Contacts',
    footerLegalPrivacy: 'Privacy Policy',
    footerLegalOffer: 'Public Offer',
    footerLegalSecurity: 'Security',
    footerAddress: 'Address:',
    footerEmail: 'E-mail:',
    footerPhone: 'Phone:',
    footerCopyright: '© 2025 shai.academy | All rights reserved',
    footerPrivacy: 'Privacy Policy',
  },
};

